var _defs, _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectCardPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4a4a4a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeOpacity: 0.07,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 120,
    r: 180,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 120,
    r: 120,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160,420 280,350 400,420 400,560 280,630 160,560",
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 310,
    textAnchor: "middle",
    fontFamily: "'JetBrains Mono', 'Courier New', monospace",
    fontSize: 110,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 0.9
  }, "&lt;/&gt;")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 400,
    textAnchor: "middle",
    fontFamily: "'JetBrains Mono', 'Courier New', monospace",
    fontSize: 30,
    letterSpacing: 10,
    fill: "#ffffff",
    fillOpacity: 0.5
  }, "\n    PROJECT PREVIEW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCardPlaceholder);
export default __webpack_public_path__ + "static/media/project-card-placeholder.6e2ed0a99e06472b1578e89176646653.svg";
export { ForwardRef as ReactComponent };